import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);


export default new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'Home',
            meta: {layout: 'default'},
            component: () => import('@/views/DanSchmidt.vue')
        },
        {
            path: '/paintings',
            name: 'Paintings',
            meta: {layout: 'gallery'},
            component: () => import('@/components/Paintings.vue')
        },
        {
            path: '/drawings',
            name: 'Drawings',
            meta: {layout: 'drawings'},
            component: () => import('@/components/Drawings.vue')
        },
        {
            path: '/photos',
            name: 'Photos',
            meta: {layout: 'photos'},
            component: () => import('@/components/Photos.vue')
        },
        {
            path: '/works',
            name: 'Works',
            meta: {layout: 'works'},
            component: () => import('@/components/OtherWorks.vue')
        },
        {
            path: '/admin/admin',
            name: 'Admin',
            meta: {layout: 'gallery'},
            component: () => import('@/admin/Admin.vue')
        },
        {
            path: '/admin/add',
            name: 'AddPainting',
            meta: {layout: 'gallery', requiresAuth: true},
            component: () => import('@/admin/AddDisplay.vue')
        },
        {
            path: '/signup',
            name: 'SignUp',
            meta: {layout: 'gallery'},
            component: () => import('@/components/SignUp.vue')
        },
        {
            path: '/writing/another-story',
            name: 'another_story',
            meta: {layout: 'works'},
            component: () => import('@/pages/works/A_little_off_the_wall_humor.vue')
        },
    ]
});
